// extracted by mini-css-extract-plugin
export default {"overlay":"Vy-z","bodyOpen":"Wy-z","content":"Xy-z","header":"Yy-z","close":"Zy-z","closeNoHeading":"_y-z"};